module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-silent-face-svgrepo-com.64d71cf7.svg";